/**
 * Utilidades para persistencia de estado en localStorage
 * Funciones compartidas entre diferentes composables
 */

// 🔄 PERSISTENCIA: Funciones para guardar/restaurar la vista por paciente
export const guardarVistaDelPaciente = (patientId, modo, titulo) => {
  if (!patientId) return;

  try {
    const key = `patient_last_view_${patientId}`;
    const vistaData = {
      modo,
      titulo,
      timestamp: Date.now()
    };
    localStorage.setItem(key, JSON.stringify(vistaData));
  } catch (error) {
    console.error('Error guardando vista del paciente:', error);
  }
};

export const restaurarVistaDelPaciente = (patientId) => {
  if (!patientId) return null;

  try {
    const key = `patient_last_view_${patientId}`;
    const saved = localStorage.getItem(key);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error('Error restaurando vista del paciente:', error);
  }

  return null;
};

// 📝 Funciones para guardar/restaurar estado de edición de formularios
export const guardarEstadoEdicion = (patientId, modo, currentId, resourceType) => {
  if (!patientId || !currentId || currentId <= 0) return;

  try {
    const key = `patient_editing_state_${patientId}`;
    const estadoEdicion = {
      modo,
      currentId,
      resourceType, // 'nota', 'receta', 'documento'
      timestamp: Date.now()
    };
    localStorage.setItem(key, JSON.stringify(estadoEdicion));
  } catch (error) {
    console.error('Error guardando estado de edición:', error);
  }
};

export const restaurarEstadoEdicion = (patientId) => {
  if (!patientId) return null;

  try {
    const key = `patient_editing_state_${patientId}`;
    const saved = localStorage.getItem(key);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error('Error restaurando estado de edición:', error);
  }

  return null;
};

export const limpiarEstadoEdicion = (patientId) => {
  if (!patientId) return;

  try {
    const key = `patient_editing_state_${patientId}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error limpiando estado de edición:', error);
  }
};

// 🔄 Funciones de mapeo de recursos a modos
export const getResourceModeMapping = (resourceApi) => {
  const mappings = {
    'patient-medical-notes': {
      editMode: 'editar-nota',
      createMode: 'nueva-nota',
      resourceType: 'nota'
    },
    'patient-medical-prescriptions': {
      editMode: 'editar-receta',
      createMode: 'nueva-receta',
      resourceType: 'receta'
    },
    'patient-documents': {
      editMode: 'editar-documento',
      createMode: 'nuevo-reporte', // o 'documentos' según el contexto
      resourceType: 'documento'
    }
  };

  return mappings[resourceApi] || null;
};